export const HEALTH_POLL_MS = 15_000
export const ACTIVITY_POLL_MS = 30_000
export const STATS_POLL_MS = 60_000
export const SIDEBAR_DOT_POLL_MS = 30_000

export const SERVICE_BUS_POLL_MS = 30_000

export const QUEUE_DEPTH_WARNING = 100
// Unprocessed messages below this count are normal in-flight backlog — pipeline
// is healthy as long as it's draining. Only flag yellow above this threshold.
export const UNPROCESSED_WARNING = 50

/** Selectable windows for the failed-message card. 0 = all time. */
export const FAILED_RANGES: ReadonlyArray<{ days: number; label: string }> = [
  { days: 3, label: '3d' },
  { days: 7, label: '7d' },
  { days: 30, label: '30d' },
  { days: 365, label: '1y' },
  { days: 0, label: 'All' },
]
export const FAILED_DEFAULT_DAYS = 3
